module.exports = __webpack_public_path__ + "static/img/hotelface.8d83bd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BrandGya/hotelface.png
// module id = 1140
// module chunks = 18